import { enUS as loginEnUS } from './Locale/Login/enUS';
import { esES as loginEsES } from './Locale/Login/esES';
import { ptBR as loginPtBR } from './Locale/Login/ptBR';
import { env } from '@/config/env';
import type { IOnboardTemplate } from '@/Templates/Onboard/Types/OnboardTemplate.types';

const WaterOnboard: IOnboardTemplate = {
  logo: `${env.cdnURL}/Utilities/Water/logo-utilities.webp`,
  logo_dark: `${env.cdnURL}/Utilities/Water/logo-utilities-dark.webp`,
  art_desktop: `${env.cdnURL}/Utilities/Debug/onboardArt.webp`,
  art_desktop_dark: `${env.cdnURL}/Utilities/Debug/onboardArt.webp`,
  art_mobile: `${env.cdnURL}/Utilities/Water/water-onboard-art-mob.webp`,
  art_mobile_dark: `${env.cdnURL}/Utilities/Water/water-onboard-art-mob.webp`,
  login: {
    locale: {
      ptBR: loginPtBR,
      enUS: loginEnUS,
      esES: loginEsES,
    },
  },
};

export { WaterOnboard };
